import Vue from 'vue'

const defaultState = () => ({
  currentPatientData: null,
  fetching: null,
  notes: [],
})

const formatLastEditDate = (lastEditDate) => {
  return Vue.$date(lastEditDate * 1000).format('DD MMM YYYY')
}

export default {
  namespaced: true,
  state: defaultState(),
  getters: {
    getNotes: (state) => state.notes,
    getCurrentPatient: (state) => state.currentPatientData,
    isFetching: (state) => state.fetching,
  },
  mutations: {
    setCurrentPatient(state, payload) {
      state.currentPatientData = payload
    },
    setAsFetching(state, payload) {
      state.fetching = payload
    },
    resetNotes(state) {
      const newState = defaultState()

      Object.entries(newState).forEach(([prop, value]) => {
        Vue.set(state, prop, value)
      })
    },
    setPatientNotes(state, notes) {
      state.notes = notes
    },
  },
  actions: {
    async fetchPatientNotes({ commit }, patientId) {
      try {
        commit('setAsFetching', true)
        const { data: notes } = await Vue.$http('patient/notes/fetchNotes', patientId)

        commit('setPatientNotes', notes.map((note) => ({
          ...note,
          formattedLastEditDate: formatLastEditDate(note.last_edit.date),
        })))
      } catch (e) {
        console.log(`[notes] error fetching notes of patient ${patientId}:`, e)
      } finally {
        commit('setAsFetching', false)

      }
    },
    async createNote({ commit, getters }, payload) {
      try {
        const { data: newNote } = await Vue.$http('patient/notes/createNote', getters.getCurrentPatient.user_id, { body: payload })

        commit('setPatientNotes', [{ ...newNote, formattedLastEditDate: formatLastEditDate(newNote.last_edit.date) }, ...getters.getNotes])
      } catch (e) {
        console.error(`[notes] error saving note of patient ${getters.getCurrentPatient.user_id}:`, e)
      }
    },
    async updateNote({ commit, getters }, payload) {
      const ids = { patientId : getters.getCurrentPatient.user_id, noteId: payload.id }

      try {
        const { data: updatedNote } = await Vue.$http('patient/notes/updateNote', ids, { body: payload })
        const updatedNotes = [
          { ...updatedNote, formattedLastEditDate: formatLastEditDate(updatedNote.last_edit.date) },
          ...getters.getNotes.filter((note) => note.id !== payload.id ),
        ]

        commit('setPatientNotes', updatedNotes)

      } catch (e) {
        console.error(`[notes] error saving note of patient ${getters.getCurrentPatient.user_id}:`, e)
      }
    },
    async deleteNote({ getters, commit }, noteId) {
      const ids = { patientId : getters.getCurrentPatient.user_id, noteId }

      try {
        await Vue.$http('patient/notes/deleteNote', ids)
        commit('setPatientNotes', getters.getNotes.filter((note) => note.id !== noteId))
      } catch (e) {
        console.error(`[notes] error saving note of patient ${getters.getCurrentPatient.user_id}:`, e)
      }
    },
    async toggleNotes({ commit, dispatch, getters, rootGetters }, patientInfo) {
      if (getters.getCurrentPatient && patientInfo.user_id === getters.getCurrentPatient.user_id) {
        const areNotesOpened = rootGetters['general/isModalOpened']('notes')

        commit('general/toggleShowModal', { notes: !areNotesOpened }, { root: true })

        return
      }
      commit('resetNotes')
      commit('setCurrentPatient', patientInfo)
      commit('general/toggleShowModal', { notes: true }, { root: true })
      dispatch('fetchPatientNotes', patientInfo.user_id)
    },
  },
}
